export const SET_PRICE = 'SET_PRICE';
export const CLEAR_PRICE = 'CLEAR_PRICE';

export function setPrice(price) {
    return {
        type: SET_PRICE,
        price
    };
}
export function clearPrice() {
    return {
        type: CLEAR_PRICE,
    };
}







// WEBPACK FOOTER //
// ./src/redux/actions/price.js